@if (reviews && reviews.length > 0) {
  <div class="component_container">
    <div class="grid-container">
      @if (showLeftArrow()) {
        <button class="scroll-arrow scroll-arrow-left" (click)="scrollLeft()">
          <mat-icon>chevron_left</mat-icon>
        </button>
      }
      <div class="wrapper" #gridWrapper (scroll)="checkScrollArrows()">
        <div class="reviews_collumns_or_row">
          @for (review of firstHalf; track $index) {
            <div>
              <app-review-grid-cell [review]="review"></app-review-grid-cell>
            </div>
          }
        </div>

        @if (reviews.length > 3) {
          <div class="reviews_collumns_or_row review_collumn_2">
            @for (review of secondHalf; track $index) {
              <div>
                <app-review-grid-cell [review]="review"></app-review-grid-cell>
              </div>
            }
          </div>
        }
      </div>
      @if (showRightArrow()) {
        <button class="scroll-arrow scroll-arrow-right" (click)="scrollRight()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>
  </div>
}
